import { createSlice } from "@reduxjs/toolkit";

const sidebarSlice = createSlice({
  name: "sidebar",
  initialState: {
    width: 0,
    headerHeight: 0,
    activeRequestsCount: 0,
    salesRequestsCount: 0,
  },
  reducers: {
    setSidebarWidth: (state, action) => {
      state.width = action.payload;
    },
    setHeaderHeight: (state, action) => {
      state.headerHeight = action.payload;
    },
    setActiveRequestsCount: (state, action) => {
      state.activeRequestsCount = action.payload;
    },
    setSalesRequestsCount: (state, action) => {
      state.salesRequestsCount = action.payload;
    },
  },
});

export const {
  setSidebarWidth,
  setHeaderHeight,
  setActiveRequestsCount,
  setSalesRequestsCount,
} = sidebarSlice.actions;
export default sidebarSlice.reducer;
